// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".usage-header[data-v-fe51d218] {\n  color: #A6A4A6;\n}", ""]);
// Exports
module.exports = exports;
